import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SgTrimParamsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.body) return next.handle(req);

    const restrictedProperties = ['__proto__', 'constructor', 'prototype'];

    Object.keys(req.body).forEach((key) => {
      if (req.body.hasOwnProperty(key) && !restrictedProperties.includes(key)) {
        if (req.body[key] && typeof req.body[key] === 'string') {
          req.body[key] = req.body[key].trim();
        }
      }
    });

    return next.handle(req);
  }
}
